













import Vue from 'vue'
import Answers from './Answers.vue'
import Inputs from './Inputs.vue'
import EndMessage from './EndMessage.vue'
import Alphabet from './Alphabet.vue'

export default Vue.extend({
  name: 'Game',
  components: {
    Answers,
    Inputs,
    EndMessage,
    Alphabet
  },
  computed: {
    success (): boolean {
      return this.$store.state.success
    },
    failure (): boolean {
      return this.$store.state.failure
    }
  },
  mounted () {
    this.$store.dispatch('getAnswer')
  }
})
